import { TOTAL_CART_SUCCESS } from 'store/actionTypes/addToCart'

export const changeTotalCartActionSuccess = (payload) => ({
  type: TOTAL_CART_SUCCESS,
  payload,
})
